import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useContext } from 'react';

import { MessageContext } from '../contexts/message';


export default function MessageDialog({ message, type, confirmCallback = () => {} }) {
  const { isOpen, setIsOpen } = useContext(MessageContext);

  const styles = {
    'error': {
      'bg': 'bg-[#de3f3f]',
      'text': 'text-white',
    },
    'info': {
      'bg': 'bg-white',
      'text': 'text-gray-500',
    },
    'warning': {
      'bg': 'bg-[#d47b1a]',
      'text': 'text-white',
    },
    'confirm': {
      'bg': 'bg-white',
      'text': 'text-gray-600',
    },
  };

  const currentStyle = styles[type];

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="absolute z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`w-full max-w-md transform overflow-hidden rounded-2xl  p-6 text-left align-middle shadow-xl transition-all ${currentStyle.bg}`}>
                  <div className="">
                    <p className={`text-sm ${currentStyle.text}`}>
                      {message}
                    </p>
                  </div>
                  <div className="mt-4 flex justify-center">
                    {type === 'confirm' && (
                      <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 me-4"
                        onClick={() => {confirmCallback(); closeModal();}}
                      >
                        Conferma
                      </button>
                    )}
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                      onClick={closeModal}
                    >
                      Chiudi
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
